export { ContainerRef, IInfiniteScrollEvent, IPositionElements, IPositionStats, IResolver } from './models'

export { InfiniteScrollDirective } from './modules/infinite-scroll.directive'
export { InfiniteScrollModule } from './modules/infinite-scroll.module'
